export const Filter = {
  APPLY: "APPLY_FILTERS",
  CANCEL: "CANCEL_FILTERS",
  SELECT: "SELECT_FILTER",
  UNSELECT: "UN_SELECT_FILTER",
  CANCEL_APPLIED_FILTERS: "CANCEL_APPLIED_FILTERS",
};
